import { render, staticRenderFns } from "./MainSlide.vue?vue&type=template&id=407bd79b&"
import script from "./MainSlide.vue?vue&type=script&lang=ts&"
export * from "./MainSlide.vue?vue&type=script&lang=ts&"
import style0 from "./MainSlide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports